import { render, staticRenderFns } from "./examinationInterface.vue?vue&type=template&id=7de74b52&"
import script from "./examinationInterface.vue?vue&type=script&lang=js&"
export * from "./examinationInterface.vue?vue&type=script&lang=js&"
import style0 from "./examinationInterface.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports